module.exports = {"230703006":"文明社区","230703007":"利民社区","230703008":"新建社区","230703009":"梧桐社区","230703010":"城林社区","230703011":"建国社区","230703012":"和平社区","230703013":"兴林社区","230703014":"红星社区","230703015":"东风社区","230703016":"向阳社区","230703101":"晨明镇","230703102":"浩良河镇","230703200":"迎春乡","230703400":"三岔河林场","230703401":"四合营林场","230703402":"亮子河林场","230703403":"石头河林场","230703405":"岩石经营所","230703406":"奋斗经营所","230703407":"桦阳经营所","230703408":"浩良河经营所","230703409":"太平经营所","230703410":"南岔经营所","230703411":"威岭经营所","230703413":"松青经营所","230703414":"柳树经营所","230703579":"浩良河化肥厂"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230703.json
// module id = 742
// module chunks = 0